<template>
    <div>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <payment-form
                v-if="campaign && !loading"
                :campaign="campaign"
                @alert="showAlert"
        />
        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </div>

</template>

<script>
    import Alert from "../Alert"
    import {alertMixin} from "../../mixins/AlertMixin"
    import PaymentForm from "./PaymentForm"
    import FairApi from "../../modules/api";

    export default {
        name: "payment",
        mixins: [alertMixin],
        components: {Alert, PaymentForm},
        props: {
            campaignId: {
                type: [String, Number],
                required: true
            }
        },
        data() {
            return {
                campaign: null,
                loading: true
            }
        },
        created() {
            this.fetchCampaign()
        },

        methods: {
            fetchCampaign: function () {
                this.loading = true
                FairApi.get(FairApi.campaign(this.campaignId), this.fetchCampaignSuccess, this.fetchCampaignFailed)
            },

            fetchCampaignSuccess: function (response) {
                this.campaign = response
                this.loading = false
            },

            fetchCampaignFailed: function () {
                this.loading = false
            }
        }
    }
</script>

